import State from "slotworks/state-machine/states/state";
import soundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import gameState from "slotworks/model/game-state";
import DSComponents from "components/components";
import BonusRecord from "integration/revolver/schema/bonus-record";
import ICSpinRecord from "integration/revolver/schema/spin-record";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import ShowPromoFSafterFreespins from "slotworks/commands/promo-free-spins/show-pfs-after-freespins";
import { StartBaseMusic } from "commands/music";

export default class Jackpot extends State {

    public onEnter() {
        const record = gameState.getCurrentGame().latestRecord();
        const prevRecord = gameState.getCurrentGame().getPreviousRecord()
        const isBonus = record instanceof BonusRecord; 
        const isSpin = isBonus ? prevRecord instanceof ICSpinRecord : record instanceof ICSpinRecord;

        if(campaignsModel.isFreespinsActive() && isSpin) {
            Layers.PromoBetBar.hide();
            Layers.SmartButton.hide();
        }
        
        // no mediator for now, unnecessary    
        this.start().then(() => {
            if(isSpin) {                
                // soundManager.customEvent("base_reels_background_start");
                StartBaseMusic(true);
                if(campaignsModel.isFreespinsActive()) {
                    ShowPromoFSafterFreespins();
                }
            }         
            regulation.updateNetPosition(gameState.getNetPosition());   
            this.complete();
        });

        const freespins = campaignsModel.freespins;
        if(freespins) {
            try {
                Components.promoBetBar.setTotalWin(freespins.totalWin);
            }catch(e) {

            }
        }
    }

    private start():Contract<void> {
        let winnings;
        if (gameState.getCurrentGame().getCurrentRecord().beenPaid) {
            winnings = gameState.getCurrentGame().totalCreditsWon;
        } else {
            const current = gameState.getCurrentGame().getCurrentRecord();
            winnings = current.creditsWon;            
            if(winnings === 0)
                winnings = gameState.getCurrentGame().previousRecord().creditsWon;            
        }
        return DSComponents.jackpotComponent.show(winnings);
    }

    public onExit() {
        super.onExit();
    }
}